var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('button',{staticClass:"nostyle",on:{"click":_vm.handler}},[_c('p',[_vm._v(_vm._s(_vm.$t('logout')))]),_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/icon-quit.svg")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }